import React from 'react';
import type { Node } from 'ricos-schema';
import { Decoration_Type } from 'ricos-schema';
import type { ItalicDecoration, NodeViewDecorator } from 'ricos-types';

const decorator = (element: JSX.Element, italicDecoration: ItalicDecoration) => {
  const { italicData } = italicDecoration;
  const isItalic = typeof italicData === 'undefined' || italicData;
  return (
    <em key={`italic-${element.key}`} style={{ fontStyle: isItalic ? 'italic' : 'normal' }}>
      {element}
    </em>
  );
};

const ItalicDecorator: NodeViewDecorator<JSX.Element> = {
  rule: (node: Node) =>
    !!node.textData?.decorations?.some(({ type }) => type === Decoration_Type.ITALIC),
  decorate: ({ element, node }) => {
    const italicDecoration = node.textData?.decorations?.find(
      ({ type }) => type === Decoration_Type.ITALIC
    ) as ItalicDecoration;
    return decorator(element as JSX.Element, italicDecoration);
  },
};

export default ItalicDecorator;
